let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("h1tW8")).then(() => parcelRequire('abuh9'));